// src/hooks/useAlert.ts
import Swal from "sweetalert2";

export const useAlert = () => {
  const showAlert = ({
    title,
    text,
    icon = "info",
    confirmButtonText = "OK",
  }: {
    title: string;
    text: string;
    icon?: "success" | "error" | "warning" | "info" | "question";
    confirmButtonText?: string;
  }) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText,
    });
  };

  return { showAlert };
};
